<template>
  <div class="seasidetms_breadcrumbs">
    <div class="seasidetms_breadcrumbs_aligner"></div>
    <div class="seasidetms_breadcrumbs_inner">
      <nav
        class="woocommerce-breadcrumb"
        itemscope
        itemtype="http://schema.org/BreadcrumbList"
      >
        <span>
          <router-link :to="lang ? '/' + lang : '/'" itemprop="item">
            {{ $t('title.main') }}
          </router-link>
        </span>
        <span
          v-for="(link, li) in breadcrumbsLinks"
          :key="`bread${li}`"
          itemprop="itemListElement"
          itemscope
          itemtype="http://schema.org/ListItem"
        >
          &nbsp;/&nbsp;
          <router-link
            :to="lang ? '/' + lang + link.to : link.to"
            itemprop="item"
          >
            <small itemprop="name">
              {{ link.name }}
            </small>
            <meta itemprop="position" :content="li + 1" />
          </router-link>
        </span>
        <span v-if="breadcrumbActive">
          &nbsp;/&nbsp;
          {{ breadcrumbActive.name }}
        </span>
      </nav>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Breadcrumbs',
  jsonld() {
    const list = [
      {
        name: this.$t('title.main'),
        to: this.lang ? '/' + this.lang : '/',
      },
      ...this.breadcrumbsLinks,
    ]
    return {
      '@context': 'http://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: list.map(({ to, name }, index) => ({
        '@type': 'ListItem',
        position: index,
        item: {
          '@id': window.location.origin + to,
          name: name,
        },
      })),
    }
  },
  computed: {
    breadcrumbsLinks() {
      let breadcrumbs = [...this.breadcrumbs]
      breadcrumbs.pop()
      return breadcrumbs
    },
    breadcrumbActive() {
      let breadcrumbs = [...this.breadcrumbs]
      return breadcrumbs.pop()
    },
    ...mapState(['breadcrumbs']),
  },
  data() {
    return {
      lang: '',
    }
  },
  beforeMount() {
    this.lang = this.$store.getters.lang
  },
  updated() {
    this.lang = this.$store.getters.lang
  },
}
</script>

<style>
small.active {
  color: rgba(255, 67, 0, 0.9);
}
</style>
